<template>
  <div id="info-sidebar" v-if="dataisload" class="product-info custom-align">
    <div class="custom-align-inner-wrap">
      <div class="custom-align-inner">
        <a @click.prevent="goBackPage" class="back-shop-btn" href="#">
          <i class="icon-back-shop"></i>
          <span>Back To The Shop</span>
        </a>
        <h1 class="product-name">{{ alldatas.Name }}</h1>
        <p class="mb-2">{{ alldatas.SubTitle }}</p>
        <h3 class="product-price">
          <span class="sell-price"
            >NT$
            {{
              alldatas.EventPrice > 0 && alldatas.EventPrice < alldatas.SellPrice
                ? alldatas.EventPrice
                : alldatas.SellPrice
            }}</span
          >
          <span
            v-if="alldatas.SellPrice !== alldatas.OriginPrice || alldatas.EventPrice > 0"
            class="origin-price mx-1"
            >NT$ {{ alldatas.OriginPrice }}</span
          >
        </h3>
        <div v-if="selectedSpec.PreOrder" class="mb-2">{{ alldatas.ArrivalExplanation }}</div>
        <div class="row">
          <div class="product-color-wrap col-6 col-md-12 order-1 order-md-0">
            <p class="mb-1">{{ selected.Name }}</p>
            <div
              @click.prevent="changeImg(color.ID)"
              class="product-color"
              v-for="(color, index) in alldatas.Colors"
              :class="{ active: color.ID === selected.ID }"
            >
              <img class="img-fluid" :src="color.PintSizePictureUrl + '?w=16&h=16'" />
            </div>
          </div>
          <div class="col-6 col-md-12 mb-2 order-0 order-md-1">
            <p
              v-if="counterOpts.length !== 0 && counterOpts.length < 10"
              class="solid-out-text my-2"
            >
              即將售完
            </p>
            <p class="mb-1">尺寸</p>
            <Selector
              class="size-selector"
              @cb="selectSpec"
              :defaultTxt="'尺寸'"
              :options="selected.Specs"
              :selected="selectedSpec"
            />
          </div>
          <div class="col-6 col-md-12 mb-2 order-2">
            <p class="mb-1">數量</p>
            <Selector
              class="count-selector"
              @cb="handleCount"
              :defaultTxt="'數量'"
              :selected="counter"
              :options="counterOpts"
            />
          </div>
        </div>
        <div class="item-wish">
          <a v-if="!selected.IsFavorite" @click.prevent="addToWish" class="btn-wish" href="#">
            <i class="icon-wish"></i><span class="pl-2">加到願望清單</span>
          </a>
          <a v-else @click.prevent="removeWish" class="btn-wish" href="#">
            <i class="icon-wish-active"></i><span class="pl-2">已加到願望清單</span>
          </a>
        </div>
        <div v-if="selectedSpec.PreOrder" class="mb-3">
          <p class="mb-1">預購追加到貨時間約20-45個工作天(不包含例假日)。</p>
          <p class="mb-1">如遇延遲到貨，將盡快通知您並安排陸續出貨。</p>
          <p class="mb-1">如商品斷貨，品牌將以 mail 通知並保留取消訂單與否之權利。</p>
          <p class="mb-1">預購訂單內所包含之預購商品會以全數到倉後安排寄出，還請留意且見諒。</p>
        </div>
        <a @click.prevent="addToCart" :class="btnStyleGenerate" class="btn-add-cart" href="#">{{
          btnDescriptionGenerate
        }}</a>
        <h5>
          <div
            v-if="
              alldatas.Events.length !== 0 ||
              alldatas.GiftEvents.length !== 0 ||
              alldatas.Limit !== 0
            "
            class="product-event text-danger"
          >
            <i class="icon-discount mb-2"></i>
            <div v-if="alldatas.Limit !== 0" class="h6 py-1 text-info">
              此商品限購 {{ alldatas.Limit }} 件
            </div>
            <div v-for="(event, index) in alldatas.Events" class="h6 py-1">
              <a :href="'/campaign/' + event.ID" class="text-info">{{ event.Name }}</a>
            </div>
            <div v-for="(giftevent, index) in alldatas.GiftEvents" class="h6 py-1">
              <a :href="'/campaign/gift/' + giftevent.ID" class="text-info">{{ giftevent.Name }}</a>
            </div>
          </div>
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
import Selector from '@page/common/js/template/select';
import utmKDetect from '@global/helpers/utmKDetect';
import gtmTrace from '@global/components/tracing/gtm';
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('miniCartModule');
import fireWishlistEvent from '@global/gtm/wishlist';
import { fireAddToCart } from '@global/gtm/common';
import axios from 'axios';

export default {
  props: ['selected', 'alldatas', 'dataisload', 'hasstock', 'btndescription'],
  data() {
    return {
      selectedSpec: { Name: '尺寸', Key: 'default', ID: 'default' },
      selectedSpecID: null,
      selectedSpecKey: null,
      counter: { Name: '數量', Key: 'default', ID: 'default' },
      btnStyle: 'disabled',
      btnDescription: this.btndescription.default,
      isopen: false,
      windowHeight: 0,
      counterOpts: { Name: '數量', Key: 'default', ID: 'default' },
    };
  },
  computed: {
    btnStyleGenerate: {
      get: function () {
        if (this.alldatas.IsPreShow) {
          this.btnStyle = 'disabled';
        }

        return this.btnStyle;
      },
      set: function (newVal) {
        this.btnStyle = newVal;
      },
    },
    btnDescriptionGenerate: {
      get: function () {
        if (this.alldatas.IsPreShow) {
          this.btnDescription = this.btndescription.preshow;
        }
        return this.btnDescription;
      },
      set: function (newVal) {
        this.btnDescription = newVal;
      },
    },
  },
  methods: {
    ...mapActions(['getCartInfo']),
    goBackPage() {
      let searchStr = 'hotgirldiscount';
      let localTest = 'localhost';
      let lastUrlArray = document.referrer;
      if (lastUrlArray.indexOf(searchStr) !== -1 || lastUrlArray.indexOf(localTest) !== -1) {
        window.history.back();
      } else {
        window.location.href = '/';
      }
    },
    addToWish: function () {
      axios
        .post(API_URL.FAVORITE, {
          CustomMarketID:
            this.alldatas.CustomMarketID.substring(0, this.alldatas.CustomMarketID.indexOf('CL')) +
            'CL' +
            this.selected.ID +
            'SZ_',
        })
        .then((res) => {
          if (res.data.Code === 200) {
            if (res.data.Response) {
              this.selected.IsFavorite = true;

              fireWishlistEvent({
                color: this.selected.Name || undefined,
                id: this.alldatas.CustomMarketID,
                name: this.alldatas.Name || undefined,
                sellPrice: this.alldatas.SellPrice || undefined,
                size: this.selectedSpec.Name || undefined,
              });
            }
          } else if (res.data.Code === 401) {
            AlertDialog.alert('請先登入');
          } else {
            AlertDialog.alert('系統忙線中');
          }
        })
        .catch((error) => {
          AlertDialog.alert(error);
        });
    },
    removeWish: function () {
      axios
        .delete(API_URL.FAVORITE, {
          data: {
            CustomMarketID:
              this.alldatas.CustomMarketID.substring(
                0,
                this.alldatas.CustomMarketID.indexOf('CL'),
              ) +
              'CL' +
              this.selected.ID +
              'SZ_',
          },
        })
        .then((res) => {
          if (res.data.Code === 200) {
            if (res.data.Response) {
              this.selected.IsFavorite = false;
            }
          } else if (res.data.Code === 401) {
            AlertDialog.alert('請先登入');
          } else {
            AlertDialog.alert('系統忙線中');
          }
        })
        .catch((error) => {
          AlertDialog.alert(error);
        });
    },
    renderCounterOpts: function () {
      let c = [];
      let maxCount = 20;

      if (this.alldatas.Limit !== 0) {
        // 限購一件
        maxCount = this.alldatas.Limit;
      } else {
        // 檢查庫存
        maxCount = this.selectedSpec.Stock < 20 ? this.selectedSpec.Stock : 20;
      }

      for (let i = 0; i < maxCount; i++) {
        c.push({ Name: i + 1, Key: i + 1 });
      }

      this.counterOpts = c;
    },
    selectSpec: function (spec) {
      if (spec.Key === 'default') {
        this.btnStyleGenerate = 'disabled';
        this.btnDescriptionGenerate = this.btndescription.default;
        this.clearSpec();
        return;
      }
      this.selectedSpec = spec;
      this.selectedSpecID = spec.ID;
      this.selectedSpecKey = spec.Key;
      this.resetCounter();
      this.getBtnStatus(spec.Stock, spec.IsOutOfStock, spec.PreOrder);
      this.renderCounterOpts();
    },
    clearSpec: function () {
      this.selectedSpec = { Name: '尺寸', Key: 'default' };
      this.selectedSpecID = null;
      this.selectedSpecKey = null;
      this.counterOpts = { Name: '數量', Key: 'default' };
    },
    handleCount: function (c) {
      this.counter = c;
    },
    resetCounter: function () {
      this.counter = { Name: '數量', Key: 'default' };
    },
    changeImg: function (colorID) {
      if (this.selected.ID === colorID) return;
      this.btnReset();
      this.clearSpec();
      this.resetCounter();

      this.$emit('change-slideindex', 0);
      this.$emit('change-selected', colorID);
    },
    getBtnStatus: function (stock, isSoldOut, isPreOrder) {
      if (this.alldatas.IsPreShow) return;
      if (stock === 0 && isSoldOut && !isPreOrder) {
        // 現貨無庫存且斷貨
        this.btnStyleGenerate = 'disabled';
        this.btnDescriptionGenerate = this.btndescription.soldout;
      } else if (stock === 0 && !isPreOrder) {
        // 現貨無庫存
        this.btnStyleGenerate = 'active-mail';
        this.btnDescriptionGenerate = this.btndescription.notice;
      } else if (stock === 0 && isPreOrder) {
        // 預購無庫存
        this.btnStyleGenerate = 'active-mail';
        this.btnDescriptionGenerate = this.btndescription.notice;
      } else {
        this.btnStyleGenerate = 'active';
        this.btnDescriptionGenerate = this.btndescription.addCart;
      }
    },
    btnReset: function () {
      this.btnStyleGenerate = 'disabled';
      this.btnDescriptionGenerate = this.btndescription.default;
    },
    addToCart: function () {
      let _this = this;
      let custommarketid = this.alldatas.CustomMarketID;
      let itemSpecInfo =
        custommarketid.substring(0, custommarketid.indexOf('CL')) +
        'CL' +
        this.selected.ID +
        'SZ' +
        this.selectedSpecKey;
      let utmData = utmKDetect(itemSpecInfo) === null ? '' : utmKDetect(itemSpecInfo);

      if (this.counter.Key === 'default' && this.selectedSpec.Stock !== 0) {
        AlertDialog.alert('請選擇數量!');
        return;
      }

      this.$emit('changecmid', itemSpecInfo);

      if (this.selectedSpec === null) {
        AlertDialog.alert('請選擇尺寸');
        return;
      }
      if (
        this.selectedSpec.Stock === 0 &&
        this.selectedSpec.IsOutOfStock &&
        !this.selectedSpec.PreOrder
      ) {
        return;
      } else if (this.selectedSpec.Stock === 0) {
        $('#lb-get-product-mail').modal('show');
        return;
      }

      $.ajax({
        type: 'post',
        url: API_URL.SHOPPING_CART,
        dataType: 'json',
        data: {
          CustomMarketID: itemSpecInfo,
          Count: _this.counter.Key,
          UtmTag: utmData,
        },
        xhrFields: {
          withCredentials: true,
        },
        error: function () {
          console.log('error');
        },
        success: function (res) {
          if (res.Code === 200 || res.Code === 406) {
            _this.checkisopen = false;
            messageBox.cart('商品確認<br>已加入購物車');
            _this.getCartInfo();
            gtmTrace.addToCart({
              name: _this.alldatas.Name,
              id: itemSpecInfo,
              price:
                _this.alldatas.EventPrice > 0 &&
                _this.alldatas.EventPrice < _this.alldatas.SellPrice
                  ? _this.alldatas.EventPrice
                  : _this.alldatas.SellPrice,
              color: _this.selected.Name,
              count: _this.counter,
            });

            fireAddToCart({
              item_id: itemSpecInfo.split('SZ')[0],
              item_name: _this.alldatas.Name,
              index: 0,
              affiliation: _this.selected.Name,
              item_brand: _this.selectedSpec.Name, //size
              item_list_name: '產品內頁',
              price:
                _this.alldatas.EventPrice > 0 &&
                _this.alldatas.EventPrice < _this.alldatas.SellPrice
                  ? _this.alldatas.EventPrice
                  : _this.alldatas.SellPrice,
              quantity: _this.counter.Key,
              item_variant: _this.selectedSpec.Barcode,
            });
          } else if (res.Code === 400) {
            window.location.href = window.CategoryUrl;
          } else {
            AlertDialog.alert(res.Message);
          }
        },
      });
    },
    showSizeChart: function () {
      $('#modal-sizechart').modal('show');
    },
  },
  components: {
    Selector,
  },
  watch: {
    selected() {
      if (this.selected.Specs.length === 1) {
        this.selectedSpec = this.selected.Specs[0];
        this.selectSpec(this.selectedSpec);
      }
    },
  },
};
</script>
